const DefaultAppTitle = 'Mio Mediaportal';

export const SetAppTitle = (...chunks: (string | number | undefined)[]) =>
  (document.title = [DefaultAppTitle, ...chunks].filter(_ => _).join(' - '));

export const ResetAppTitle = () => (document.title = DefaultAppTitle);
